import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable, Subscription, Subject, throwError, interval } from 'rxjs';
import { catchError, debounceTime, switchMap, startWith, distinctUntilChanged } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { CustomerAuthService } from '@teem/app/core/services/customer-auth.service';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';
import { ProfileService } from '@teem/core/services/profile.service';
import { LoaderService } from '@teem/services/loader.service';
import { environment } from '@teem/environments/environment';
import { customer as CustomerApi } from '@teem/core/constants/api';
import { parseDate, queryString } from '@teem/helpers/functions';
import { order as OrderApi } from '@teem/core/constants/api';
import { ChangeDetectorRef } from '@angular/core';


declare var $;

@Component({
	selector: 'app-order-section',
	templateUrl: './order-section.component.html',
	styleUrls: ['./order-section.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderSectionComponent {
	searchSubscription: Subscription;
	search: Subject<string> = new Subject<string>();
	searchText: string;

	orders: any[] = [];
	params: any = {};
	paginator: any = {
		id: 'orders-table-paginator',
		currentPage: 1,
		itemsPerPage: 5, //environment.pageSize,
		totalItems: 0
	}

	// tmpOrders = [
	// 	{
	// 		title: 'Order #147094',
	// 		status: 'preparing',
	// 		timeDelivery: '25.07.24',
	// 		address: 'Old Industrial, P.O.Box: 69556, Riyadh',
	// 		logo: './images/customer-profile/Logo.png',
	// 		restaurantName: 'Premium Restaurant',
	// 		restaurantAddress: 'Jeddah, Saudi Arabia',
	// 		products: [
	// 			{ img: './images/cup.png', name: 'VR headset', amount: '5', title: 'Lorem ipsum dolor sit amet consectetur. Tincidunt imperdiet erat', price: '5903.3' },
	// 			{ img: './images/malik-new.jpg', name: 'Malik', amount: '1', title: 'Tincidunt imperdiet erat', price: '999999' },
	// 			{ img: './images/cup.png', name: 'VR headset', amount: '5', title: 'Lorem ipsum dolor sit amet consectetur. Tincidunt imperdiet erat', price: '5903.3' },
	// 			{ img: './images/malik-new.jpg', name: 'Malik', amount: '1', title: 'Tincidunt imperdiet erat', price: '999999' }
	// 		]
	// 	},
	// 	{
	// 		title: 'Order #147093',
	// 		status: 'complete',
	// 		timeDelivery: '25.07.24',
	// 		address: 'Old Industrial, P.O.Box: 69556',
	// 		logo: './images/customer-profile/Logo.png',
	// 		restaurantName: 'Premium Restaurant',
	// 		restaurantAddress: 'Jeddah, Saudi Arabia',
	// 		products: [
	// 			{ img: './images/malik-new.jpg', name: 'Malik', amount: '1', title: 'Tincidunt imperdiet erat', price: '999999' }
	// 		]
	// 	},
	// 	{
	// 		title: 'Order #147092',
	// 		status: 'delivery',
	// 		timeDelivery: '25.07.24',
	// 		address: 'Old Industrial, Riyadh',
	// 		logo: './images/customer-profile/Logo.png',
	// 		restaurantName: 'Premium Restaurant',
	// 		restaurantAddress: 'Jeddah, Saudi Arabia',
	// 		products: [
	// 			{ img: './images/malik-new.jpg', name: 'Malik', amount: '1', title: 'Tincidunt imperdiet erat', price: '999999' },
	// 			{ img: './images/cup.png', name: 'VR headset', amount: '5', title: 'Lorem ipsum dolor sit amet consectetur. Tincidunt imperdiet erat', price: '5903.3' },
	// 			{ img: './images/cup.png', name: 'VR headset', amount: '5', title: 'Lorem ipsum dolor sit amet consectetur. Tincidunt imperdiet erat', price: '5903.3' },
	// 			{ img: './images/malik-new.jpg', name: 'Malik', amount: '1', title: 'Tincidunt imperdiet erat', price: '999999' }
	// 		]
	// 	},
	// ];

	constructor(
		private loaderService: LoaderService,
		private profileService: ProfileService,
		private customerAuthService: CustomerAuthService,
		private sharedDataService: SharedDataService,
		private cdr: ChangeDetectorRef,
		private httpClient: HttpClient
	) { }

	// ngOnInit(): void {
	// 	// this.fetchOrders();
	// }

	// ngOnInit(): void {
	// 	this.searchSubscription = this.search.asObservable().pipe(debounceTime(300)).subscribe(data => {
	// 		if (this.searchText != data) {
	// 		  this.searchText = data;
	  
	// 		  if (this.searchText.length == 0 || this.searchText.length >= 3) {
	// 			this.getPage(1,'track_order',false);
	// 		  }
	// 		}
	// 	})
	// 	this.getPage(1,'track_order');
	// }

	// public getPage(page: number, section?: string, loading: boolean = true, additionalParams: any = null) {

	// 	if (loading) {
	// 		this.loaderService.startLoading();
	// 	}

	// 	let params: any = {
	// 		page: page,
	// 		limit: this.paginator.itemsPerPage
	// 	}



	// 	if (additionalParams) {
	// 		Object.assign(params, additionalParams);
	// 	}
	// 	if (this.params) {
	// 		Object.assign(params, this.params);
	// 	}


	// 	this.getData(params).subscribe(
	// 		(r) => {
	// 			if (r.meta) {
	// 				this.paginator.totalItems = r.meta.total;
	// 				this.paginator.itemsPerPage = r.meta.per_page;
	// 				this.paginator.currentPage = r.meta.current_page;
	// 				this.paginator.from = r.meta.from;
	// 				this.paginator.to = r.meta.to;
	// 				this.orders = r.data;

	// 				this.cdr.detectChanges(); // manually tell Angular to update

	// 				setTimeout(() => {
	// 					$('#tab-links-select[nice-select]').niceSelect('update');
	// 				}, 10);
	// 			}

	// 			this.loaderService.stopLoading();
	// 		}, (err) => {
	// 			this.loaderService.stopLoading()
	// 		}
	// 	)
	// }

	// getData(params): Observable<any> {
	// 	// let url = OrderApi.endPoint;
	// 	let url = CustomerApi.orders;

	// 	if (url.indexOf('?') == -1)
	// 		url += ('?' + queryString(params));
	// 	else
	// 		url += ('&' + queryString(params));

	// 	return this.httpClient.get(`${url}`).pipe(
	// 		catchError((err: any) => {
	// 			this.loaderService.stopLoading()
	// 			return throwError(err);
	// 		})
	// 	)
	// }

	// onChangePerPageItems(page: any, section?: string) {
	// 	if (page?.limit) {
	// 		this.paginator.itemsPerPage = page?.limit;
	// 		this.params.limit = page?.limit;
	// 		this.getPage(1, section,false, this.params);
	// 	}
	// }

	// fetchOrders(sortColumn?: string, sortDirection?: string, section?: string) {
	// 	this.params.order_by = sortColumn;
	// 	this.params.direction = sortDirection;
	// 	this.getPage(1, section, true, this.params)
	// }

	// get getOrders() {
	// 	return this.orders.filter(o => o.status !== 'complete');
	// }

	// get trackOrders() {
	// 	return this.tmpOrders.filter(o => o.status !== 'complete');
	// }

	// get completedOrders() {
	// 	return this.tmpOrders.filter(o => o.status === 'complete');
	// }
}